module.exports = __webpack_public_path__ + "img/ppts.2bddf30e.jpg";